import React, { useContext, useEffect, useState } from "react";
import { Tab, Tabs } from "@mui/material";
import { DeviceModelTab, ReducerContext } from "../../context";
import { WithGrow } from "@common/components/WithGrow";
import Typography from "@common/components/Typography";
import TabPanel from "@common/components/TabPanel";
import { useTranslation } from "react-i18next";
import OidTabContent from "./TabContent/OidTabContent";
import AdapterTabContent from "./TabContent/AdapterTabContent";
import MappingTabContent from "./TabContent/MappingContent";

const DeviceTabs = () => {
  const { t } = useTranslation();
  const {
    tabSelected,
    snmpEnabled,
    adapterChecked,
    propertyMappingEnabled,
    errors,
    canAccessExtendedPropertyMapping,
  } = useContext(ReducerContext);
  const [tabValue, setTabValue] = useState(tabSelected != -1 ? tabSelected : 0);
  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  const tabs: {
    label: string;
    content: React.JSX.Element;
    noPadding?: boolean;
  }[] = [];
  if (snmpEnabled) tabs.push({ label: "SNMP", content: <OidTabContent /> });
  if (adapterChecked)
    tabs.push({ label: "Adapters", content: <AdapterTabContent /> });
  if (propertyMappingEnabled)
    tabs.push({ label: "Mapping", content: <MappingTabContent /> });

  useEffect(() => {
    if (snmpEnabled || adapterChecked || propertyMappingEnabled) {
      let index = tabs.findIndex(
        (t) =>
          t.label ==
          (tabSelected === DeviceModelTab.MAPPING
            ? "Mapping"
            : tabSelected === DeviceModelTab.ADAPTERS
            ? "Adapters"
            : "SNMP")
      );

      setTabValue(index !== -1 ? index : 0);
    }
  }, [snmpEnabled, adapterChecked, propertyMappingEnabled]);

  const renderTabsView = () => (
    <WithGrow
      direction="column"
      sx={{ flexGrow: "1", overflow: "hidden" }}
      containerSx={{ display: "flex", flexDirection: "column" }}
      fixed={
        <Tabs
          value={tabValue >= tabs.length ? 0 : tabValue}
          onChange={handleTabChange}
        >
          {tabs.map(({ label }) => (
            <Tab
              key={label}
              label={
                <Typography
                  sx={(theme) => ({
                    color: `${
                      (errors.mapping && label === "Mapping") ||
                      (errors.oid && label === "SNMP")
                        ? theme.palette.error.main
                        : "inherit"
                    }`,
                  })}
                >
                  {t(label)}
                </Typography>
              }
            />
          ))}
        </Tabs>
      }
    >
      {tabs.map(({ content, label, noPadding = false }, index) => (
        <TabPanel
          key={label}
          value={tabValue >= tabs.length ? 0 : tabValue}
          index={index}
          noPadding={noPadding}
          style={{
            display: "flex",
            flexDirection: "column",
            flex: "1 0 auto",
            overflow: "hidden",
          }}
        >
          {content}
        </TabPanel>
      ))}
    </WithGrow>
  );
  return renderTabsView();
};

export default DeviceTabs;
